import * as Types from '../../../../types';
import { mapMCCEventToEvidence } from './mapMCCEventToEvidence';
import { Dispatch } from 'redux';
import { UpdateReport } from 'src/api';
import { updateReport } from 'src/creators/MCC.creators';

export const addNonExistingEvent = async (
  currentReport: UpdateReport,
  reportID: string,
  currentEvent: Types.MCCEventType,
  dispatch: Dispatch,
) => {
  const { evidence, event } = mapMCCEventToEvidence(currentEvent, reportID);

  await updateReport(reportID, {
    ...currentReport,
    perpetrators: [
      ...(currentReport.perpetrators ?? []),
      ...currentEvent.perpetrators.map((p) => ({
        name: p.name,
        id: p.id,
        external: p.external,
      })),
    ],
    evidence: {
      events: [...(currentReport.evidence?.events ?? []), event],
      evidence: [...(currentReport.evidence?.evidence ?? []), ...evidence],
    },
  })(dispatch);
};
